export default __webpack_public_path__ + "60d02a32182dc5c4db07d834cdd9ddca.webp";